import { Controller } from "@hotwired/stimulus";

export default class SlideoverController extends Controller {
  static values = {
    open: {
      default: false,
      type: Boolean,
    },
  };

  declare openValue: boolean;

  toggle(): void {
    this.openValue = !this.openValue;
  }
}
